import { render, staticRenderFns } from "./ConsignmentFilter.vue?vue&type=template&id=781f5aae"
import script from "./ConsignmentFilter.vue?vue&type=script&lang=js"
export * from "./ConsignmentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports